export const investorStatuses = Object.freeze({
  EMAIL_VERIFIED: 'email_verified',
  CONTACTS_FILLED: 'contacts_filled',
  PROFILE_FILLED: 'profile_filled',
  APPROVED: 'approved',
  PENDING: 'pending',
  INVESTMENT_SUSPENDED: 'investment_suspended',
  SUSPENDED: 'suspended',
  DECLINED: 'declined',
  CLOSED: 'closed'
})
export const registrationStatuses = [
  investorStatuses.EMAIL_VERIFIED,
  investorStatuses.CONTACTS_FILLED,
  investorStatuses.PROFILE_FILLED,
  investorStatuses.INVESTMENT_SUSPENDED
]
export default investorStatuses
